import { ClassProfileImageCard } from './ClassProfileImageCard';
export default ClassProfileImageCard;
